import { render, staticRenderFns } from "./webinarVideo.vue?vue&type=template&id=0cf69b07&scoped=true&"
import script from "./webinarVideo.vue?vue&type=script&lang=js&"
export * from "./webinarVideo.vue?vue&type=script&lang=js&"
import style0 from "./webinarVideo.vue?vue&type=style&index=0&id=0cf69b07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf69b07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
